const workflowDashboardFilters = {
  statusId: null,
  businessEntityId: null,
  clientId: null,
  assignedToUserId: null,
  targetStartDateFrom: null,
  targetStartDateTo: null
}

export default () => Object.assign({}, workflowDashboardFilters)
